import React, { useRef, useState } from "react";
import { Modal } from "components";
import AvatarEditor from "react-avatar-editor";
import { ButtonPrimary, ButtonSecondary } from "components/Atoms/Button";
import Slider from "components/Atoms/Slider";
import { Message } from "semantic-ui-react";

interface EditUploadedAvatarModalProps {
  file: File
  onClose: () => void
  onSave: (file: File) => void
}

const EditUploadedAvatarModal = (props: EditUploadedAvatarModalProps) => {
  const editor = useRef(null);
  const [scale, setScale] = useState(1);
  const [rotationDeg, setRotationDeg] = useState(0);
  const [hasError, setHasError] = useState<boolean>(false);

  const onSave = () => {
    const canvas = editor.current.getImageScaledToCanvas() as HTMLCanvasElement;
    canvas.toBlob((blob) => {
      const file = new File([blob], props.file.name, { type: blob.type });
      props.onSave(file);
    });
  };

  return (
    <Modal
      isOpen
      width="large"
      style={{ maxWidth: 640 }}
      title={RESX.Buttons.UploadPhoto}
      handleClose={props.onClose}
    >
      {hasError && <Message color="red">
        There was an issue loading the image. Please try again.
      </Message>}
      {!hasError && <>
        <div className="grow1 scrollbox-auto">
          <div className="edit-avatar-background">
            <AvatarEditor
              ref={editor}
              image={props.file}
              width={400}
              height={400}
              border={[96, 48]}
              scale={scale}
              rotate={rotationDeg}
              onLoadFailure={() => { setHasError(true); }}
              color={[0, 0, 0, 0.6]}
            />
          </div>
        </div>
        <div className="flex gap-large align-center">
          <div className="grow1">
            <Slider
              min={0.1}
              initialValue={scale}
              max={2}
              step={0.05}
              onChange={(value) => { setScale(value); }}
            />
          </div>
          <div className="flex gap-small">
            <ButtonSecondary
              label=""
              iconLeft="icon-repeat"
              onClick={() => { setRotationDeg((rotationDeg + 90) % 360); }}
            />
            <ButtonSecondary
              label=""
              iconLeft="icon-undo"
              onClick={() => { setRotationDeg((rotationDeg - 90) % 360); }}
            />
          </div>
          <ButtonPrimary
            label={RESX.Buttons.btnSave}
            onClick={onSave}
          />
        </div>
      </>}
    </Modal>
  );
};

export default EditUploadedAvatarModal;